import home from '../images/home2.jpg';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import '../components/css components/home.css';
import about from'../components/About';
import 'animate.css';
import { useEffect } from 'react';
import WOW from 'wowjs';

function Home(){
    useEffect(() => {
        const wow = new WOW.WOW({
          live: false
        });
        wow.init();
      }, []);
    return(
        <div className='home' id='#home'> 
            <img src={home} alt="home"/>
            <Container>
            <div className='words'>
                <h2 className='animate__animated animate__backInLeft'>welcome to our community</h2>
                <h1><span>MEGA</span>Team</h1>
                <a href='##about'><button className='button animate__animated animate__backInLeft'>About Us</button></a>
            </div>
            </Container>
        </div> 

        
    );
}

export default Home;